import { useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { GET_SIMPLE_LEARNING_PATHS_OR_PLAYLISTS_QUERY } from '../../../../__generated__/chirp/com/hubspot/learning/center/playlists/rpc/LearningPathChirpService.dfc.new';
export const useSimplePlaylists = ({
  playlistIds,
  skip
}) => {
  const {
    data,
    loading: simplePlaylistsLoading,
    error: simplePlaylistsError,
    apolloError
  } = useQuery(GET_SIMPLE_LEARNING_PATHS_OR_PLAYLISTS_QUERY, {
    variables: {
      playlistIds
    },
    skip: skip || !playlistIds.length
  });
  return {
    simplePlaylists: (data === null || data === void 0 ? void 0 : data.results.reduce((acc, playlist) => {
      acc[playlist.id] = playlist;
      return acc;
    }, {})) || null,
    simplePlaylistsLoading,
    simplePlaylistsError,
    apolloError
  };
};